import React from "react";

export function AdUpload() {
    return <h1>Coming Soon!</h1>
}